import _ from "lodash";
import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
export const kioskGlobalHelper = {
  dimensions: [
    dimensionEnum.KIOSK,
    dimensionEnum.KIOSK_NAME,
    dimensionEnum.SITE,
    dimensionEnum.SITE_NAME,
    dimensionEnum.SITE_CURRENCY,
  ],

  getQueries(filters, timeDimension) {
    const queries = [
      {
        query: {
          measures: [
            mesureEnum.PURCHASEHISTORY_AMOUNT,
            mesureEnum.PURCHASEHISTORY_AMOUNTCB,
            mesureEnum.PURCHASEHISTORY_AMOUNTCASH,
            mesureEnum.PURCHASEHISTORY_TOKEN,
            mesureEnum.PURCHASEHISTORY_BONUSTOKEN,
            mesureEnum.PURCHASEHISTORY_COUNTSOLDCARDS,
          ],
          dimensions: this.dimensions,
          timeDimensions: timeDimension
            ? [{ ...timeDimension, dimension: dimensionEnum.PURCHASEHISTORY_DATETIME }]
            : [],
          filters: [
            ...filters,
            TableTools.Helper.getFilterPurchaseHistoryNotBirthday(),
          ],
        },
      },
      // Récupération de tous les jeux même s'ils n'ont pas eu d'activité
      {
        query: {
          measures: [],
          dimensions: this.dimensions,
          filters: [
            filters.find((filter) => filter.dimension === dimensionEnum.SITE),
            TableTools.Helper.getFilterKioskNotDeleted(),
          ],
        },
      },
      // ATTENTION : Requête liée à pré-aggregation, si modif -> à répercuter dans SnackHistory.js
      {
        query: {
          measures: [mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC],
          dimensions: this.dimensions,
          timeDimensions: timeDimension ? [timeDimension] : [],
          filters: filters,
        },
      },
    ];
    return queries;
  },
  addSnackHistoryCbColumns(dataTable) {
    return dataTable.map((data) => {
      TableTools.Helper.renameKey(
        data,
        mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC,
        alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC
      );
      data[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT] =
        (data[mesureEnum.PURCHASEHISTORY_AMOUNT] || 0) +
        (data[alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC] || 0);

      return data;
    });
  },
  addPercentageColumn(dataTable, totalRevenueSite) {
    return dataTable.map((data) => {
      const kioskRevenue =
        data[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT] || 0;
      data[calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE] = totalRevenueSite
        ? (kioskRevenue * 100) / totalRevenueSite
        : 0;

      return data;
    });
  },
  addPaymentMethodPercentageColumn(dataTable, totalsData) {
    const
      percentCbCol = calculatedColumnsEnum.PERCENT_TOTAL_CB,
      percentCashCol = calculatedColumnsEnum.PERCENT_TOTAL_CASH,
      cumulativeCol = calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT,
      cbCol = mesureEnum.PURCHASEHISTORY_AMOUNTCB,
      cashCol = mesureEnum.PURCHASEHISTORY_AMOUNTCASH;

    const calculatePercentages = (data) => {
      const total = data[cumulativeCol] || 0;
      data[percentCbCol] = total ? ((data[cbCol] | 0) / total) * 100 : 0;
      data[percentCashCol] = total ? ((data[cashCol] | 0) / total) * 100 : 0;
      return data;
    };

    // Détail par kiosque
    const dataByKiosk = dataTable.map(calculatePercentages);

    // Total
    calculatePercentages(totalsData);

    return { data: dataByKiosk, total: totalsData };
  },
  addBonusTokenPercentageColumn(dataTable) {
    return dataTable.map((data) => {
      const totalTokens =
        data[mesureEnum.PURCHASEHISTORY_TOKEN] +
        data[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0;
      data[calculatedColumnsEnum.BONUS_TOKENS_RATIO] = totalTokens
        ? (data[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] / totalTokens) * 100
        : 0;
      return data;
    });
  },
  addBonusTokenTotalPercentage(dataTable, totalsData) {
    // Calculate the sum of all bonus tokens and total tokens across all rows
    const totalBonusTokens = _.sumBy(
      dataTable,
      (row) => row[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0
    );
    const totalTokens = _.sumBy(
      dataTable,
      (row) =>
        (row[mesureEnum.PURCHASEHISTORY_TOKEN] || 0) +
        (row[mesureEnum.PURCHASEHISTORY_BONUSTOKEN] || 0)
    );

    // Calculate the total percentage for bonus tokens
    const bonusTokenPercentage =
      totalTokens !== 0 ? (totalBonusTokens / totalTokens) * 100 : 0;

    // Add this percentage to the totalsData object
    totalsData[calculatedColumnsEnum.BONUS_TOKENS_RATIO] = bonusTokenPercentage;

    return totalsData;
  },
};
